<template>
  <img
    v-if="next"
    ref="imgLazy"
    class="lazyload blur-up"
    data-sizes="auto"
    :id="config.elID"
    :class="config.elClass"
    :src="picture.lazy.url"
    :data-srcset="`
      ${picture[1400].url} 1400w,
      ${picture[1080].url} 1080w,
      ${picture[750].url} 750w,
      ${picture[640].url} 640w,
      ${picture[480].url} 480w,
      ${picture[320].url} 320w,
      ${picture[240].url} 240w,
    `"
    :style="{ 'object-fit': config.objectFit }"
  />
</template>

<script>
import _ from "lodash";

export default {
  props: {
    config: {
      type: Object,
      default() {
        return {
          id : '',
          imageRaw: String,
          mode: String,
          cropPosX: Number,
          cropPosY: Number,
          cropWidth: Number,
          cropHeight: Number,
          maxWidthDesktop: Number,
          maxWidthTablet: Number,
          maxWidthMobile: Number,
          objectFit: String,
          quality: Number
        };
      },
    },
  },
  computed: {
    picture() {
      return {
        1400: this.$helper.imageCrop.imageOptions("desktop", {...this.config, ...{maxWidthDesktop : this.sizes[1400].w}}),
        1080: this.$helper.imageCrop.imageOptions("desktop", {...this.config, ...{maxWidthDesktop : this.sizes[1080].w}}),
        750: this.$helper.imageCrop.imageOptions("desktop", {...this.config, ...{maxWidthDesktop : this.sizes[750].w}}),
        640: this.$helper.imageCrop.imageOptions("desktop", {...this.config, ...{maxWidthDesktop : this.sizes[640].w}}),
        480: this.$helper.imageCrop.imageOptions("desktop", {...this.config, ...{maxWidthDesktop : this.sizes[480].w}}),
        320: this.$helper.imageCrop.imageOptions("desktop", {...this.config, ...{maxWidthDesktop : this.sizes[320].w}}),
        240: this.$helper.imageCrop.imageOptions("desktop", {...this.config, ...{maxWidthDesktop : this.sizes[240].w}}),
        lazy: this.$helper.imageCrop.imageOptions("lazy", this.config),
      };
    },
  },
  data() {
    return {
      next: true,
      observer: {},
      sizes: {
          "1400" : {
            w: 1920, // 1920
            h: 1920,
          },
          "1080": {
            w: 1400, // 1110
            h: 1400,
          },
          "750": {
            w: 1080, // 666
            h: 1080,
          },
          "640": {
            w: 750, // 555
            h: 750,
          },
          "480": {
            w: 640, // 444
            h: 640,
          },
          "320": {
            w: 480, // 370
            h: 480,
          },
          "240": {
            w: 320, // 278
            h: 320,
          }
        }
    };
  },
  methods: {
    initObserverImgLazy() {
      this.observer.imgLazy = new MutationObserver((mutations) => {
        for (const m of mutations) {
          const newValue = m.target.getAttribute(m.attributeName);
          this.$nextTick(() => {
            this.watchImgLazyClass(newValue, m.oldValue);
          });
        }
      });
      this.observer.imgLazy.observe(this.$refs.imgLazy, {
        attributes: true,
        attributeOldValue: true,
        attributeFilter: ["class"],
      });
    },
    clearObserverImgLazy() {
      this.observer.imgLazy.disconnect();
    },

    watchImgLazyClass(newValue, oldValue) {
      const classes = newValue.split(" ");
      const classesOld = oldValue.split(" ");
      if (
        !classesOld.includes("lazyloaded") &&
        classes.includes("lazyloaded")
      ) {
        this.$emit("lazyloaded");
      }
    },
  },
  watch: {
    picture: {
      deep: true,
      handler(newValue, oldValue) {
        if (!_.isEqual(newValue, oldValue)) {
          this.next = false;
          this.$nextTick(() => {
            this.next = true;
          });
        }
      },
    },
  },
  mounted() {
    this.initObserverImgLazy();
  },
  beforeDestroy() {
    this.clearObserverImgLazy();
  },
};
</script>

<style scoped>
img {
  width: 100%;
  height: auto;
}
img * {
  min-width: 100%;
  height: auto;
}

.lazyload {
  height: 100%;
}

.blur-up.lazyloading {
  height: 100%;
}

/* .blur-up {
  -webkit-filter: blur(5px);
  filter: blur(5px);
  transition: filter 1500ms, -webkit-filter 1500ms;
}

.blur-up.lazyloaded {
  -webkit-filter: blur(0);
  filter: blur(0);
} */
</style>
